import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import LazyImage from "../../shared/lazy-image";
import { Text } from "@cars24/turbo-web/lib/text";

const EliteNumbers = ({
    section
}) => {

    const {pageSection = {} } = section || {};
    const { sectionData = [], image } = pageSection || {};
    const { url, alternativeText } = image || {};

    return (
        <div styleName={"styles.eliteNumbersWrapper"}>
            <div styleName={"styles.nubmerBg"}>
                <LazyImage src={url} alt={alternativeText} />
            </div>
            <div styleName={"styles.numberTextWrapper"}>
                {
                    sectionData.map((item, index) => (
                        <div key={`elite-numbers-${index}`} styleName={"styles.numberText"}>
                            <Text
                                align="center"
                                as="p"
                                fontWeight="bold"
                                size="550"
                                transform="none"
                                color={"#FFFFFF"}
                            >
                                {item.title}
                            </Text>
                            <Text
                                align="center"
                                as="p"
                                fontWeight="regular"
                                size="400"
                                transform="none"
                                color={"#FFFFFF"}
                            >
                                {item.subTitle}
                            </Text>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

EliteNumbers.propTypes = {
    section: PropTypes.object
};

export default EliteNumbers;
